import React from 'react';
import { Section } from './ui/Section';
export function Videos() {
  return <Section id="videos" className="bg-tx-midnight" data-id="element-181">
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6" data-id="element-182">
        <div data-id="element-183">
          <h2 className="text-5xl md:text-7xl text-tx-parchmentLight uppercase" data-id="element-184">
            Live <span className="text-tx-blue" data-id="element-185">Performances</span>
          </h2>
          <p className="text-tx-parchmentLight/60 font-body text-lg mt-4 max-w-2xl" data-id="element-186">
            Experience the energy of a Texarkana show. From intimate acoustic
            sets to full-blown honky-tonk throwdowns.
          </p>
        </div>
      </div>

      <div className="max-w-5xl mx-auto" data-id="element-187">
        <div className="relative group" data-id="element-188">
          {/* Decorative offset border */}
          <div className="absolute inset-0 bg-tx-blue/20 translate-x-3 translate-y-3 md:translate-x-4 md:translate-y-4 border border-tx-blue/30 transition-transform duration-500 group-hover:translate-x-5 group-hover:translate-y-5" data-id="element-189"></div>

          <div className="relative z-10 bg-tx-midnight border border-tx-saddle overflow-hidden" data-id="element-190">
            <video controls className="w-full aspect-video object-cover" poster="https://cdn.magicpatterns.com/uploads/qkKkd9idCDJgxkW68nbzYS/hotel-california.mov#t=0.1" data-id="element-191">
              <source src="https://cdn.magicpatterns.com/uploads/qkKkd9idCDJgxkW68nbzYS/hotel-california.mov" type="video/mp4" data-id="element-192" />
              Your browser does not support the video tag.
            </video>
            <div className="p-6 bg-tx-midnight border-t border-tx-saddle" data-id="element-193">
              <h3 className="font-heading text-3xl text-tx-parchmentLight tracking-wider uppercase" data-id="element-194">
                Band Rehearsal
              </h3>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}